import { render, staticRenderFns } from "./Rooms.vue?vue&type=template&id=29992f63&scoped=true"
import script from "./Rooms.vue?vue&type=script&lang=js"
export * from "./Rooms.vue?vue&type=script&lang=js"
import style0 from "./Rooms.vue?vue&type=style&index=0&id=29992f63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29992f63",
  null
  
)

export default component.exports